import { blueGrey } from '@mui/material/colors';
import { ruRU as coreRuRU } from '@mui/material/locale';
import type { PaletteMode } from '@mui/material/styles';
import { alpha, createTheme, responsiveFontSizes } from '@mui/material/styles';
import { ruRU as datagridRuRU } from '@mui/x-data-grid/locales';
import '@mui/x-data-grid/themeAugmentation';
import { ruRU as datePickersRuRU } from '@mui/x-date-pickers/locales';
import '@mui/x-date-pickers/themeAugmentation';

const getInitialMode = (): PaletteMode => {
  if (typeof document === 'undefined') return 'light'; // Для SSR

  // Читаем атрибут, который уже установлен в index.html
  const mode = document.documentElement.getAttribute('data-theme') as PaletteMode;
  return mode ?? 'light';
};

const mode = getInitialMode();

console.log('mode', mode);

let theme = createTheme(
  {
    colorSchemes: {
      dark: true,
      light: true,
    },
    components: {
      MuiInputBase: {
        styleOverrides: {
          root: (props) => ({
            '&:has([readonly]:not([aria-hidden="true"]))': {
              backgroundColor: alpha(
                '#fffbd0',
                props.theme.palette.action.disabledOpacity
              ),
            },
          }),
        },
      },
      MuiDataGrid: {
        defaultProps: {
          pageSizeOptions: [10, 25, 50, 100],
          initialState: {
            pagination: {
              paginationModel: {
                page: 0,
                pageSize: 25,
              },
            },
          },
        },
      },
    },
    palette: {
      mode,
    },
  },
  coreRuRU,
  datagridRuRU,
  datePickersRuRU
);

if (mode === 'light') {
  theme.palette.background.default = blueGrey[50];
}

theme = responsiveFontSizes(theme);

export default theme;
